import { __ } from 'i18n/index';

/** Display names of an LFG card's or posted result's `mode`. */
export const MODE_NAMES = {
	friendlies: __('Friendlies'),
	ranked: __('Ranked'),
	doubles: __('Doubles'),
};
